import { Link } from "gatsby"
import React, { useEffect, useState,useRef } from "react"
import { DateRangePicker } from "react-date-range"
import ModalTiny from "react-bootstrap/Modal"
import "react-date-range/dist/styles.css" // main css file
import "react-date-range/dist/theme/default.css" // theme css file
import {
  axiosInstance,
  getAvailableDates,
  getBookingPriceDetails,
  getTaxPrice,
  getTotalGuests,
  isDateInArray,
  numberFormat,
} from "../../common/site/utils"
import "../DateRangeSelect/DateRangeSelect.scss"
import GuestButton from "../GuestButton/GuestButton";
import GuestCoupon from "../GuestCoupon/GuestCoupon";
import "./ContactDetails.scss"
import ReservationModule from "../ReservationModule/ReservationModule"
import { format } from "date-fns"
import clsx from "clsx"
import BookAViewForm from "../forms/book-a-viewing-form"
const axios = require("axios");

const HolidayContactDetails = props => {
  const peopleCapacity = props.peopleCapacity
  const { accommodationMasterCode, userCode, crm_id, loginGA } = props
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
    key: "selection",
  })
  const datePickerRef = useRef(null);
  //const [reservationCouponId, setReservationCouponId] = useState(null);
  let reservationCouponId = '';
  // useEffect(() => {
  //   const storedCouponId = localStorage.getItem('reservationCouponId');

  //   if (storedCouponId) {
  //     console.log("Retrieved reservationCouponId:", storedCouponId);
  //     setReservationCouponId(storedCouponId); 
  //   }
  // }, []);
  const handleCouponApply = (couponId,ranges) => {
    //console.log(couponId,"reservationCouponId3333")
    reservationCouponId = couponId

    handleDateChangedemo(ranges);
    // You might also want to call handleDateChangedemo here if needed
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setShowDatePicker(false);
      }
    };

    if (showDatePicker) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDatePicker]);

  const [dateRangedemo, setDateRangedemo] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  })
  const [availabilityData, setAvailabilityData] = useState(null);
  const [minStayMap, setMinStayMap] = useState({}); // Initialize state for minimum stay
  const [showsModel, setShowsModel] = useState(false); // Initialize state for error message
  const [checksAvailability, setChecksAvailability] = useState(false)

  const [modalSendfrndformOpen, setSendfrndformOpen] = useState(false)
  const openSendfrndformModal = () => {
    setSendfrndformOpen(true)
  }
  const closeSendfrndformModal = () => {
    setSendfrndformOpen(false)
  }

  const formatDate = date => {
    const formatedDate = format(new Date(date), "yyyy-MM-dd")
    return formatedDate
  }
  // const formatDate = date => {
  //   return date.toISOString().split('T')[0];
  // };

  const formatDateDisplay = date => {
    const formatedDate = format(new Date(date), "dd-MM-yyyy")
    return formatedDate
  }
  const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI3NzA3MSIsImp0aSI6IjExZjBlNjdlNmFmZDBmYzNmN2M5Njg1YjcxOGE1Y2Y0YTFlZDMyZjE2OWE3MzJjYTE5OTNjYTUzYmJkY2IzZjQ4NTAxMjAzY2FhMDJjNzZhIiwiaWF0IjoxNzE4MTA3Mjc1LjM0ODQ0MiwibmJmIjoxNzE4MTA3Mjc1LjM0ODQ0MywiZXhwIjoyMDMzNjQwMDc1LjM0ODQ0Nywic3ViIjoiIiwic2NvcGVzIjpbImdlbmVyYWwiXSwic2VjcmV0SWQiOjM0MjkyfQ.JEXZ305Asbu1zoMvKFwIOflMM0UERObxDEMNde2JvMO2k77e9w74oFkD2AoU933Q7CViXLrL5xaRwAWHQCN72V5SslKPcWsMeAnvfGJM4FDRSAKrJZSmcOm9L_EZXAZgU0zcWhQu2AvtKbxiLBajYCll8KiDEoRFgYMmsiXE5RA'

  const [disabledDatesdemo, setDisabledDatesdemo] = useState([]);
  const [errorMsgMinStay, SeterrorMsgMinStay] = useState("")
  const [bookingReqstData, setbookingReqstData] = useState(null)
  const [bookingDisplaysData, setBookingDisplaysData] = useState(null)
  const [bookingPriceData, setbookingPriceData] = useState(null)
  const [availableDates, setavailableDates] = useState(null)
  const [minstays, setminstays] = useState(null)
  const [minstayDay, setminstayDay] = useState(null)
  const [guestsNo, setGuestsNo] = useState({
    adults: 0,
    children: 0,
  })
  useEffect(() => {
    setbookingReqstData(prevState => ({
      ...prevState,
      adultsNumber: guestsNo.adults,
      childsNumber: guestsNo.children,
    }));  }, [guestsNo]);
  // Fetch availability data
  // Fetch availability data once when component mounts
  useEffect(() => {
    const fetchAvailabilityData = async () => {
      try {
        
        const response = await axios.get(`https://api.hostaway.com/v1/listings/${props.crm_id}/calendar`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        setAvailabilityData(response.data);

        // Extract disabled dates from the API response
        const disabledDates = response.data.result
          .filter(item => item.isAvailable === 0)
          .map(item => new Date(item.date));

        const minStayMaps = response.data.result.reduce((acc, item) => {
          acc[item.date] = item.minimumStay; // Create a map of dates to minimum stays
          return acc;
        }, {});
        setMinStayMap(minStayMaps)
        setDisabledDatesdemo(disabledDates);
      } catch (error) {
        console.error('Error fetching availability data:', error);
      }
    };

    fetchAvailabilityData();
  }, [token]);
  const errorMsgMinStayCheck = () => {
    return errorMsgMinStay !== "";
  };
  // Filter available dates based on fetched availability data
  const isDateAvailable = (date) => {

    if (!availabilityData || !availabilityData.result) {
      return false;
    }

    const dateStr = formatDate(date);

    // Check availability
    const isAvailable = availabilityData.result.some(item => {
      return item.date === dateStr && item.isAvailable === 1;
    });

    return isAvailable;
  };





  // Handle date range change
  const handleDateChangedemo = async (ranges) => {
    const { startDate, endDate } = ranges.selection;
   // console.log(ranges.selection,"ranges.selection")
    if (!startDate || !endDate) {
      console.warn('Start or End date is not selected properly.');
      return;
    }


    const daysBetween = Math.ceil((new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24));
    const allDates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= new Date(endDate)) {
      allDates.push(currentDate.toISOString().split('T')[0]); // YYYY-MM-DD format
      currentDate.setDate(currentDate.getDate() + 1);
    }

    const availabilityReqsDatas = {
      listingMapId: props.crm_id,
      userCode: 33334,
      accommodationMasterCode: 737383,
      loginGA: "456738RD",
      adultsNumber: guestsNo.adults,
      childsNumber: guestsNo.children,
      // child1_Age: "6",
      dateFrom: startDate,
      dateTo: endDate,
      arrivalDate: startDate,
      departureDate: endDate,
    }
    const formattedStartDate = format(new Date(startDate), 'dd-MM-yyyy');
  const formattedEndDate = format(new Date(endDate), 'dd-MM-yyyy');
    const bookPriceBody = {
      "startingDate": formattedStartDate,
      "endingDate": formattedEndDate,
      "numberOfGuests": 2,
      "version": "2",
      reservationCouponId: reservationCouponId
    }
    setbookingReqstData(availabilityReqsDatas)
    const minStays = formatDate(new Date(startDate));
    const minStaysdays = minStayMap[minStays];
    setminstayDay(minStaysdays)
    let meetsMinStay = daysBetween >= minStaysdays;
    setminstays(!meetsMinStay);
    if (daysBetween >= minStaysdays) {
      meetsMinStay = false
      setminstays(meetsMinStay)
      SeterrorMsgMinStay("")
    } else {
      meetsMinStay = true
      setminstays(meetsMinStay)
      SeterrorMsgMinStay(`Minimum stay is ${minStaysdays} night`)
    }


   
    let avableCheck = false;
    const availableDates = [new Date(startDate), new Date(endDate)].every(date => isDateAvailable(date));

    if (availableDates) {
      setDateRangedemo({
        startDate: new Date(startDate),
        endDate: new Date(endDate),
        key: 'selection'
      });
      setavailableDates(availableDates)
      
     
      //setShowsModel(true)
      avableCheck = true
      setChecksAvailability(avableCheck)
      const bookingPriceData = await fetchBookingPrice(bookPriceBody);
      setbookingPriceData({
        totalPrice: bookingPriceData?.result?.totalPrice,
        currency: "AED",
      })
      //setbookingPriceData(bookingPriceData);
      const reservationData = getBookingPriceDetails(props, bookingPriceData, {
        startDate,
        endDate,
      })
      setBookingDisplaysData(reservationData)
    } else {
      console.warn('Selected dates are not available.');
    }
  };

  const fetchBookingPrice = async (requestData) => {
    try {
      requestData.crm_id = props.crm_id;
      // const response = await axiosInstance.post(
      //   "/stb-feed-importer/hostaway/sendPriceDetails",
      //   requestData
      // )
      //console.log(response,"Respod")
      const response = await axios.post(`https://api.hostaway.com/v1/listings/${props.crm_id}/calendar/priceDetails`, requestData, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching booking price data:', error);
      return null;
    }
  };
  const checkingsAvailability = async () => {
    setShowsModel(true)

  }
  // Custom day renderer to apply styling
  const CustomDayContent = ({ date }) => {
    // Ensure date is a valid Date object
    if (!date || !(date instanceof Date)) {
      console.warn("Invalid date object:", date);
      return <div className="day-content">N/A</div>;
    }

    // Convert date to string format for comparison
    const dateString = date.toISOString().split('T')[0];

    // Check if the date is disabled
    const isDisabled = disabledDatesdemo.some(disabledDate =>
      disabledDate.toISOString().split('T')[0] === dateString
    );

    return (
      <div className={`day-content ${isDisabled ? 'disabled' : ''}`}>
        {date.getDate()} {/* Display the day number */}
      </div>
    );
  };

  const [showModal, setShowModal] = useState(false)

  const [checkingAvailability, setCheckingAvailability] = useState(false)
  const [isAvailable, setIsAvailable] = useState(false)
  const [showGuestsInput, setShowGuestsInput] = useState(false)

  const [bookingDisplayData, setBookingDisplayData] = useState(null)
  const [bookingReqData, setBookingReqData] = useState(null)
  const [paymentData, setPaymentData] = useState(null)

  const [errorMsg, SetErrorMsg] = useState("")

  const [startDate, setStartDate] = useState("Add Date")
  const [endDate, setEndDate] = useState("Add Date")

  const [startDisplayDate, setStartDisplayDate] = useState("Add Date")
  const [endDisplayDate, setEndDisplayDate] = useState("Add Date")

  const [disabledDates, setDisabledDates] = useState([])
 

  // reset when date is changed
  useEffect(() => {
    setIsAvailable(false)
    setCheckingAvailability(false)
    setBookingDisplayData(null)
    setBookingReqData(null)
    setPaymentData(null)
    SetErrorMsg("")
    return () => { }
  }, [startDate, endDate, guestsNo, startDisplayDate, endDisplayDate])

  // reset when modal is closed
  useEffect(() => {
    if (!showModal) {
      setStartDate("Add Date")
      setEndDate("Add Date")
      setStartDisplayDate("Add Date")
      setEndDisplayDate("Add Date")
      setGuestsNo({
        adults: 0,
        children: 0,
      })
      setIsAvailable(false)
      setCheckingAvailability(false)
      setBookingDisplayData(null)
      setBookingReqData(null)
      setPaymentData(null)
      SetErrorMsg("")
      setDateRange({
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      })
    }
  }, [showModal])

  // get unavailable dates
  useEffect(() => {
    const availableDates = getAvailableDates(props.availabilities)

    const allDatesTillOneYear = []
    const now = new Date()
    for (let i = 0; i < 365; i++) {
      allDatesTillOneYear.push(new Date(now.setDate(now.getDate() + 1)))
    }

    const unavailableDates = []
    if (availableDates?.length > 0) {
      allDatesTillOneYear.forEach(date => {
        if (!isDateInArray(availableDates, date)) {
          unavailableDates.push(date)
        }
      })
    }

    setDisabledDates(unavailableDates)

    return () => { }
  }, [])

  const handleDateChange = range => {
    setDateRange(range.selection)
    const start = formatDate(range.selection.startDate)
    const end = formatDate(range.selection.endDate)

    const startDispaly = formatDateDisplay(range.selection.startDate)
    const endDispaly = formatDateDisplay(range.selection.endDate)

    setStartDate(start)
    setEndDate(end)

    setStartDisplayDate(startDispaly)
    setEndDisplayDate(endDispaly)

    setIsAvailable(false)
  }

  const checkAvailability = async () => {
    if (!isAvailable) {
      setShowModal(true)
      return
    }

    setShowGuestsInput(false)
    const totalGuests = getTotalGuests(guestsNo)

    if (
      startDate === "Add Date" &&
      endDate === "Add Date" &&
      startDisplayDate === "Add Date" &&
      endDisplayDate === "Add Date"
    ) {
      SetErrorMsg("Please choose a valid check-in and check-out date.")
      return
    } else if (!totalGuests || totalGuests < 1) {
      SetErrorMsg("Please add atleast 1 guest.")
      return
    } else if (guestsNo?.adults === 0) {
      SetErrorMsg("Please add atleast 1 adults.")
      return
    } else {
      SetErrorMsg(null)
    }

    setCheckingAvailability(true)

    const availabilityReqData = {
      accommodationCode: crm_id,
      userCode: userCode,
      accommodationMasterCode: accommodationMasterCode,
      loginGA: loginGA,
      adultsNumber: totalGuests,
      // child1_Age: "6",
      dateFrom: startDate,
      dateTo: endDate,
      arrivalDate: startDate,
      departureDate: endDate,
    }

    setBookingReqData(availabilityReqData)

    // console.log(
    //   "🚀 ~ file: HolidayContactDetails.js:68 ~ checkAvailability ~ availabilityReqData",
    //   availabilityReqData
    // )

    try {
      const res = await axiosInstance.post(
        "/stb-feed-importer/avantio/isAvailability",
        availabilityReqData
      )
      // console.log(
      //   "🚀 ~ file: HolidayContactDetails.js:78 ~ checkAvailability ~ data",
      //   res
      // )

      if (res.status === 200) {
        if (res.data?.Available?.AvailableCode === "1") {
          const reservationData = await axiosInstance.post(
            "/stb-feed-importer/avantio/getBookingPrice",
            availabilityReqData
          )
          // console.log(
          //   "🚀 ~ file: HolidayContactDetails.js:147 ~ checkAvailability ~ reservationData",
          //   reservationData
          // )
          if (reservationData?.status === 200) {
            const bookingData = getBookingPriceDetails(reservationData.data, {
              startDate,
              endDate,
            })

            // console.log(
            //   "🚀 ~ file: HolidayContactDetails.js:190 ~ checkAvailability ~ bookingData.totalPrice:",
            //   bookingData.totalPrice
            // )
            if (
              isNaN(bookingData.totalPrice) ||
              parseInt(bookingData.totalPrice) < 1
            ) {
              SetErrorMsg(
                "Something went wrong, please try again with different dates."
              )
              setIsAvailable(false)
              return
            }

            setPaymentData({
              totalPrice: bookingData.totalPrice,
              currency: bookingData.currency,
            })
            setBookingDisplayData(bookingData.displayData)

            setIsAvailable(true)
          } else {
            if (reservationData?.status === 204) {
              SetErrorMsg("No data found")
            } else {
              SetErrorMsg("Something went wrong")
            }

            setIsAvailable(false)
          }
        } else {
          SetErrorMsg(res.data?.Available?.AvailableMessage || "Not Available")
          setIsAvailable(false)
        }
      }
    } catch (error) {
      console.error("🚀 ~  checkAvailability ~ error", error)
      throw new Error(error)
    } finally {
      setCheckingAvailability(false)
    }
  }

  
  return (
    <>
      <div className="holiday-card-wrap card-wrap">
        <h2>
          {props.currency ? props.currency : "AED "}
          {numberFormat(props.price)}
          <span class="duration">per night</span>
        </h2>
        <div className="content-wrap">
          <div className="in-out-section-wrap">
            <div
              className="in-out-section"
              onClick={() => {
                setShowDatePicker(prev => !prev)
              }}
            >
              <div className="check-in">
                <span>Check In</span>
                <p>
                  {dateRangedemo && dateRangedemo.startDate
                    ? format(dateRangedemo.startDate, 'dd-MM-yyyy')
                    : 'Not selected'}
                </p>
              </div>
              <div className="check-out">
                <span>Check Out</span>
                <p>
                  {dateRangedemo && dateRangedemo.endDate
                    ? format(dateRangedemo.endDate, 'dd-MM-yyyy')
                    : 'Not selected'}
                </p>
              </div>
            </div>
            {errorMsgMinStay && (
              <div class="alert alert-danger" role="alert">
                {errorMsgMinStay}
              </div>
            )}
            {showDatePicker && (
              <div ref={datePickerRef} className="date-picker-wrapper">
              <DateRangePicker
                ranges={dateRangedemo ? [dateRangedemo] : []}
                onChange={handleDateChangedemo}
                weekdayDisplayFormat="EEEEE"
                dateDisplayFormat="dd-MM-yyyy"
                showClearDate={true}
                editableDateInputs={false}
                moveRangeOnFirstSelection={false}
                disabledDates={disabledDatesdemo}
                minDate={new Date()}
                renderDayContent={CustomDayContent}
              />
            </div>
            )}
          </div>
          <GuestButton
            setGuestsNo={setGuestsNo}
            guestsNo={guestsNo}
            showGuestsInput={showGuestsInput}
            setShowGuestsInput={setShowGuestsInput}
            peopleCapacity={peopleCapacity}
          />
          <GuestCoupon
            bookingReqData={bookingReqstData}
            bookingDisplayData={bookingDisplaysData}
            onCouponApply={handleCouponApply} 
          />
        </div>
        {guestsNo && guestsNo && (
          <ReservationModule
            showModal={showsModel}
            setShowModal={setShowsModel}
            propertyData={props}
            bookingReqData={bookingReqstData}
            bookingDisplayData={bookingDisplaysData}
            paymentData={bookingPriceData}
          />
        )}{" "}
        {errorMsg && (
          <div class="alert alert-danger" role="alert">
            {errorMsg}
          </div>
        )}
        {bookingDisplayData && (
          <div className="booking-info-wrap">
            {bookingDisplayData.map(data => (
              <div className="info-row">
                <div className="label">{data[0]}</div>
                <div className="value">{data[1]}</div>
              </div>
            ))}
          </div>
        )}
        {bookingDisplaysData && !errorMsgMinStayCheck() &&(
          <div className="price-details">
            <div className="price-summary">
              <span>Total price</span>
              <span>{Math.round(bookingDisplaysData.totalPrice)} {bookingDisplaysData.currency}</span>
            </div>
            {!showDetails && (
              <span
                onClick={() => setShowDetails(prev => !prev)}
                className="toggle-details-view"
                >
                View details
                <span className="arrowdown"></span>
                </span>
            )}
            {showDetails && (
              <>
                <div className="details">
                  {bookingDisplaysData.displayData.map(([item, cost], index) => (
                    <div key={index} className="detail-item">
                      <span>{item}</span>
                      <span>{cost}</span>
                    </div>
                  ))}
                </div>
                <span
                  onClick={() => setShowDetails(prev => !prev)}
                  className="toggle-details"
                >
                  Hide
                  <span className="arrowup"></span> 
                  </span>
              </>
            )}
          </div>
        )}
        <div className="btn-wrap top-20">
          <a
            className={clsx(
              "request-view",
              //checksAvailability && "button--loading" // Uncomment if needed for loading state
            )}
            onClick={() => {
              let errorMessage = "";
              if (minstays) {
                SeterrorMsgMinStay("");
              } else {
                SeterrorMsgMinStay(`Minimum stay is ${minstayDay} nights`); 
              }
              
              if (guestsNo.adults <= 0) {
                errorMessage = "Please select at least one guest.";
              }

              if (!availableDates) {
                errorMessage = "Selected dates are not available for booking.";
              }

              if (errorMessage) {
                SeterrorMsgMinStay(errorMessage);
              } else {
                SeterrorMsgMinStay("");

                if (checksAvailability) {
                  checkingsAvailability();
                }
              }
            }}
          >
            <span>{"Make a Reservation"}</span>
          </a>
          <a
            href="javascript:void(0)"
            className="request-callback"
            onClick={openSendfrndformModal}
          >
            Make an enquiry
          </a>
        </div>
      </div>
      <ModalTiny
        show={modalSendfrndformOpen}
        onHide={closeSendfrndformModal}
        className="book-a-viewing-modal modal-main-form modal"
      >
        <i className="icon-close" onClick={() => closeSendfrndformModal()}></i>

        <ModalTiny.Body className="people-details-form-modal event-section">
          <h2>Make an enquiry</h2>
          <p>
            For more information, please leave a few details below and a member
            of our team will be in contact soon.
          </p>
          <BookAViewForm
            page_url={props.pageurl}
            property_title={props.property_title}
            property_img={props.property_img}
          />
        </ModalTiny.Body>
      </ModalTiny>
    </>
  )
}

export default HolidayContactDetails
